import { getConfig } from 'EnvConfig'
import { bootLogoUrl, syncLoginLogoPreload } from 'utils/login-logo-preload'

const requestThemeData = async (
  orgId: string,
  designId: string
): Promise<unknown> => {
  const response = await fetch(
    `${
      getConfig().DESIGN_BUILDER_API_URL
    }/designs/${designId}/parse?theme=NEW&orgId=${orgId}`
  )

  if (!response.ok) {
    throw new Error(`Theme request failed (${response.status})`)
  }

  return response.json()
}

let primed: { key: string; promise: Promise<unknown> } | undefined

const toKey = (orgId: string, designId: string) => `${orgId}/${designId}`

export const primeThemeData = (
  orgId: string,
  designId: string,
  options?: { fallbackLogoUrl?: string }
): Promise<unknown> => {
  const key = toKey(orgId, designId)

  if (primed?.key === key) return primed.promise

  const promise = requestThemeData(orgId, designId)

  promise.then(
    (payload) => {
      const url = bootLogoUrl(payload, options?.fallbackLogoUrl)

      if (!url) return

      const existing = document.head.querySelector(
        'link[data-ecp-login-logo-preload]'
      )
      const isHeaderFallback = url === options?.fallbackLogoUrl

      if (isHeaderFallback && existing) return

      syncLoginLogoPreload(url)
    },
    () => undefined
  )
  primed = { key, promise }

  return promise
}

export const fetchThemeData = (
  orgId: string,
  designId: string
): Promise<unknown> => {
  const handoff = primed

  // Consumed once, so later design changes and remounts hit the network.
  primed = undefined

  if (handoff?.key !== toKey(orgId, designId)) {
    return requestThemeData(orgId, designId)
  }

  return handoff.promise.catch(() => requestThemeData(orgId, designId))
}
